<template>
  <sub-section
    title="Choose the annual growth rate on your investments"
    helpTitle="Growth projections"
    :helpText="HelpText.growthProjections()"
    :showHelp="showRiskHelp"
  >
    <p class="mb-0">On investments in your defined contribution pension pots</p>
    <risk-selector
      ref="pensionRiskSelector"
      key="pensionRiskSelector"
      mode="Pensions"
      aria-label=" the amount of risk you are willing to take on investments in your defined contribution pension pots by 0.5%"
    />

    <p class="mb-0 mt-4">On investments in your savings pots</p>
    <risk-selector
      ref="savingsRiskSelector"
      key="savingsRiskSelector"
      mode="Savings"
      aria-label=" the amount of risk you are willing to take on investments in your savings pots by 0.5%"
    />

    <p
      v-if="showRateText"
      id="riskWarningMessage"
      class="risk-warning mt-4"
      style=""
    >
      You have chosen to use estimated annual growth of
      <strong
        ><span id="pensionsReturnRiskMsgVal">{{ pensionsReturnRate }}</span
        >%</strong
      >
      on your defined contribution pension pots and
      <strong
        ><span id="savingsReturnRiskMsgVal">{{ savingsReturnRate }}</span
        >%</strong
      >
      on your savings pots.
      <span v-html="riskBasedOnText()"></span>
    </p>
    <p v-else class="risk-warning mt-4">
      There will always be some risk involved in accessing your pension using
      the pension freedoms. If you want to take no risk at all a guaranteed
      income for life (annuity) may be a better choice.
    </p>
  </sub-section>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import RiskSelector from "@/guiide/components/design/RiskSelector.vue";
import HelpText from "@/guiide/ts/helpText";
import { RiskConfiguration } from "@/guiide/ts/configuration/riskConfiguration";

export default defineComponent({
  name: "DecideOnRisk",
  components: {
    SubSection,
    RiskSelector
  },
  setup() {
    const pensionRiskSelector = ref(null);
    const savingsRiskSelector = ref(null);
    return {
      pensionRiskSelector,
      savingsRiskSelector,
      HelpText
    };
  },
  computed: {
    pensionsReturnRate: function(): number {
      return this.$store.state.retiree?.returnOnPensions ?? 3;
    },
    savingsReturnRate: function(): number {
      return this.$store.state.retiree?.returnOnSavings ?? 3;
    },
    showRateText: function(): boolean {
      return this.pensionsReturnRate > 1;
    },
    showRiskHelp: function(): boolean {
      return this.$store.state.configuration.designShowRiskHelp;
    }
  },
  methods: {
    setDisabledState(disabled: boolean) {
      this.pensionRiskSelector.setDisabledState(disabled);
      this.savingsRiskSelector.setDisabledState(disabled);
    },
    riskBasedOnText(): string {
      const risk = this.$store.state.configuration.risk as RiskConfiguration;
      return risk.basedOnText;
    }
  }
});
</script>
